import { WorkspaceActionTypes } from './workspace.types';
import { IWorkspace } from '../../types';

// Get all workspaces action creators
export const getAllWorkspacesRequest = () => ({
  type: WorkspaceActionTypes.GET_ALL_WORKSPACES_REQUEST,
});

export const getAllWorkspacesSuccess = (workspaces: IWorkspace[]) => ({
  type: WorkspaceActionTypes.GET_ALL_WORKSPACES_SUCCESS,
  payload: workspaces,
});

export const getAllWorkspacesFailure = (error: string) => ({
  type: WorkspaceActionTypes.GET_ALL_WORKSPACES_FAILURE,
  payload: error,
});

// Get admin workspaces action creators
export const getAdminWorkspacesRequest = (params?: { isAdmin?: boolean }) => ({
  type: WorkspaceActionTypes.GET_ADMIN_WORKSPACES_REQUEST,
  payload: params,
});

export const getAdminWorkspacesSuccess = (workspaces: IWorkspace[]) => ({
  type: WorkspaceActionTypes.GET_ADMIN_WORKSPACES_SUCCESS,
  payload: workspaces,
});

export const getAdminWorkspacesFailure = (error: string) => ({
  type: WorkspaceActionTypes.GET_ADMIN_WORKSPACES_FAILURE,
  payload: error,
});

// Get archived workspaces action creators
export const getArchivedWorkspacesRequest = () => ({
  type: WorkspaceActionTypes.GET_ARCHIVED_WORKSPACES_REQUEST,
});

export const getArchivedWorkspacesSuccess = (workspaces: IWorkspace[]) => ({
  type: WorkspaceActionTypes.GET_ARCHIVED_WORKSPACES_SUCCESS,
  payload: workspaces,
});

export const getArchivedWorkspacesFailure = (error: string) => ({
  type: WorkspaceActionTypes.GET_ARCHIVED_WORKSPACES_FAILURE,
  payload: error,
});

// Archive workspace action creators
export const archiveWorkspaceRequest = (workspaceId: string) => ({
  type: WorkspaceActionTypes.ARCHIVE_WORKSPACE_REQUEST,
  payload: workspaceId,
});

export const archiveWorkspaceSuccess = (workspaceId: string) => ({
  type: WorkspaceActionTypes.ARCHIVE_WORKSPACE_SUCCESS,
  payload: workspaceId,
});

export const archiveWorkspaceFailure = (error: string) => ({
  type: WorkspaceActionTypes.ARCHIVE_WORKSPACE_FAILURE,
  payload: error,
});

// Get workspace by ID action creators
export const getWorkspaceByIdRequest = () => ({
  type: WorkspaceActionTypes.GET_WORKSPACE_BY_ID_REQUEST,
});

export const getWorkspaceByIdSuccess = (workspace: IWorkspace) => ({
  type: WorkspaceActionTypes.GET_WORKSPACE_BY_ID_SUCCESS,
  payload: workspace,
});

export const getWorkspaceByIdFailure = (error: string) => ({
  type: WorkspaceActionTypes.GET_WORKSPACE_BY_ID_FAILURE,
  payload: error,
});

// Create workspace action creators
export const createWorkspaceRequest = (workspaceData: { name: string }) => ({
  type: WorkspaceActionTypes.CREATE_WORKSPACE_REQUEST,
  payload: workspaceData,
});

export const createWorkspaceSuccess = (workspace: IWorkspace) => ({
  type: WorkspaceActionTypes.CREATE_WORKSPACE_SUCCESS,
  payload: workspace,
});

export const createWorkspaceFailure = (error: string) => ({
  type: WorkspaceActionTypes.CREATE_WORKSPACE_FAILURE,
  payload: error,
});

// Update workspace action creators
export const updateWorkspaceRequest = (workspaceData: { name: string }) => ({
  type: WorkspaceActionTypes.UPDATE_WORKSPACE_REQUEST,
  payload: workspaceData,
});

export const updateWorkspaceSuccess = (workspace: IWorkspace) => ({
  type: WorkspaceActionTypes.UPDATE_WORKSPACE_SUCCESS,
  payload: workspace,
});

export const updateWorkspaceFailure = (error: string) => ({
  type: WorkspaceActionTypes.UPDATE_WORKSPACE_FAILURE,
  payload: error,
});

// Delete workspace action creators
export const deleteWorkspaceRequest = (workspaceId: string) => ({
  type: WorkspaceActionTypes.DELETE_WORKSPACE_REQUEST,
  payload: workspaceId,
});

export const deleteWorkspaceSuccess = (workspaceId: string) => ({
  type: WorkspaceActionTypes.DELETE_WORKSPACE_SUCCESS,
  payload: workspaceId,
});

export const deleteWorkspaceFailure = (error: string) => ({
  type: WorkspaceActionTypes.DELETE_WORKSPACE_FAILURE,
  payload: error,
});

// Switch workspace action creators
export const switchWorkspaceRequest = (workspaceId: string) => ({
  type: WorkspaceActionTypes.SWITCH_WORKSPACE_REQUEST,
  payload: workspaceId,
});

export const switchWorkspaceSuccess = (workspaceId: string) => ({
  type: WorkspaceActionTypes.SWITCH_WORKSPACE_SUCCESS,
  payload: workspaceId,
});

export const switchWorkspaceFailure = (error: string) => ({
  type: WorkspaceActionTypes.SWITCH_WORKSPACE_FAILURE,
  payload: error,
});

// Clear workspace action creators
export const clearWorkspaceState = () => ({
  type: WorkspaceActionTypes.CLEAR_WORKSPACE_STATE,
});

// Remove user action creators
export const removeUserFromWorkspaceRequest = (data: { userId: string }) => ({
  type: WorkspaceActionTypes.REMOVE_USER_FROM_WORKSPACE_REQUEST,
  payload: data,
});

export const removeUserFromWorkspaceSuccess = (message: string) => ({
  type: WorkspaceActionTypes.REMOVE_USER_FROM_WORKSPACE_SUCCESS,
  payload: message,
});

export const removeUserFromWorkspaceFailure = (error: string) => ({
  type: WorkspaceActionTypes.REMOVE_USER_FROM_WORKSPACE_FAILURE,
  payload: error,
});

export const clearWorkspaceData = () => ({
  type: WorkspaceActionTypes.CLEAR_WORKSPACE_DATA,
});

// Update workspace settings action creators
export const updateWorkspaceSettingsRequest = (data: {
  duplicateEmailEnabled: boolean;
  mergeOption?: 'oldest' | 'newest';
}) => ({
  type: WorkspaceActionTypes.UPDATE_WORKSPACE_SETTINGS_REQUEST,
  payload: data,
});

export const updateWorkspaceSettingsSuccess = (data: {
  message: string;
  duplicateEmailEnabled: boolean;
}) => ({
  type: WorkspaceActionTypes.UPDATE_WORKSPACE_SETTINGS_SUCCESS,
  payload: data,
});

export const updateWorkspaceSettingsFailure = (error: string) => ({
  type: WorkspaceActionTypes.UPDATE_WORKSPACE_SETTINGS_FAILURE,
  payload: error,
});
